import axios from '../../axios';
const state = () => ({
	loading: false
});

const actions = {
	// eslint-disable-next-line no-unused-vars
	sendFeedback({ commit }, data) {
		return axios.post('/feedback', data).then(response => {
			return response.data;
		});
	},
};

const mutations = {

};

const getters = {

};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};